export default {
  en: {
    title: 'Federated suppliers',
    pageHeader: 'Suppliers',
    dataTableColumns: {
      name: 'Supplier name',
      dateAdded: 'Date added',
      federationMembersConnected: 'Sub-entities connected',
      parentConnectionStatus: 'Your connection status',
      concentrationRisk: 'Concentration risk',
      compliancePercentage: 'Average compliance score',
      location: 'Location',
      sector: 'Sector',
      networkCoverage: 'Sub-entity coverage',
      networkCoverageTooltip: 'Percentage of sub-entities connected to this supplier',
      lastAssessmentDate: 'Last assessment date',
      nextReassessmentDate: 'Next reassessment date',
      numRisks: 'Open risks',
    },
    filterAttributes: {
      name: 'Name',
      dateAdded: 'Date added',
      federationMembersConnected: 'Sub-entities connected',
      concentrationRisk: 'Concentration risk',
      concentrationRiskTrue: 'Concentration risk',
      concentrationRiskFalse: 'No concentration risk',
      parentConnectionStatus: 'Your connection status',
      parentConnectionStatusOptions: {
        full: 'Full connection',
        basic: 'Basic connection',
        notConnected: 'Not connected',
      },
      location: 'Location',
      sector: 'Sector',
    },
    placeholders: {
      emptyTitle: 'Federated suppliers',
      emptyDescription: 'No suppliers could be found',
      errorTitle: 'Federated suppliers',
      errorDescription: 'Failed fetching the federated supplier list',
    },
    misc: {
      filterResultsSuppliers: '{count} suppliers | {count} supplier | {count} suppliers',
      entityName: 'Suppliers',
      export: 'Export',
      exportError: 'There was an error attempting to export the supplier list.',
    },
  },
};
